import { Routes } from '@angular/router';
import { LoginComponent } from './layout/login/login.component';
import { LoginCallbackComponent } from './layout/login/loginCallback.component';
import { AssetManagementDashboardComponent } from './pages/asset-management/asset-management-dashboard/asset-management-dashboard.component';
import { ContractorDashboardComponent } from './pages/contractor-flow/contractor-dashboard/contractor-dashboard.component';
import { FinanceDashboardComponent } from './pages/finance/finance-dashboard/finance-dashboard.component';

export const routes: Routes = [
  { path: 'login/callback', component: LoginCallbackComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'asset-management', component: AssetManagementDashboardComponent
  },
  {
    path: 'vendor-employee', component: ContractorDashboardComponent
  },
  {
    path: 'iskill',
    loadChildren: () =>
      import('./pages/iskill/iskill.module').then((m) => m.IskillModule),
  },
  {
    path: 'finance', component: FinanceDashboardComponent
  },
  {
    path: 'productivity',
    loadChildren: () =>
      import('./pages/productivity/productivity.module').then((m) => m.ProductivityModule),
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];
